import { useEffect, useState } from "react";
import { Commons, Const } from "../constants";

import { CancelButton, ModalComponent, trans, TableComponent } from "@comps/components"
import moment from "moment";
const ViewLeaveRequestHistory = (props) => {
  const langKey = Const["leaveApproval"].lngKey
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    setData();
  }, []);

  const setData = () => {
    if (!props) {
      return;
    }
    if (props.record.histories) {
      setDataSource(props.record.histories);
    }
  }

  const footer = [
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  const columns = [
    {
      key: 'requestee',
      title: trans(`${langKey}.requestee`),
      render: (record) => {
        return <div>{ record.requestee.full_name }<br /><small>{ record.requestee.emp_code }</small></div>
      },
    },
    {
      key: 'status',
      title: trans(`${langKey}.status`),
      dataIndex: 'status'
    },
    {
      key: 'remarks',
      title: trans(`${langKey}.remarks`),
      dataIndex: 'remarks'
    },
    {
      key: 'datetime',
      title: trans(`${langKey}.datetime`),
      render: (record) => {
        return moment(new Date(record.created_at)).format('YYYY-MM-DD hh:mm a')
      }
    },
  ];
  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.view) } subTitle={ 'History' }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) } disabled={ props.disabled } loader={ true }>
      <TableComponent
        columns={ columns }
        dataSource={ dataSource }
        pagination={ false }
      />
    </ModalComponent>
  )
}

export default ViewLeaveRequestHistory